module.exports = __webpack_public_path__ + "img/exporting.55a37f04.svg";